import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TimeagoModule } from 'ngx-timeago';

import { MAP_PATH_BY_TASK_TYPE } from '@models/user-tasks';

import { IconComponent } from '@shared/components/icon/icon.component';
import { listUserTasksQuery } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { MainService } from '@shared/store/main/main.service';
import { MainStore } from '@shared/store/main/main.store';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgClass, TimeagoModule],
  selector: 'aux-portfolio-task-list',
  styles: [],
  templateUrl: './portfolio-task-list.component.html',
})
export class PortfolioTaskListComponent {
  private mainQuery = inject(MainQuery);
  private mainService = inject(MainService);
  private mainStore = inject(MainStore);
  private router = inject(Router);

  @Input() noTasksMessage = '';
  @Input() tasks!: listUserTasksQuery[];

  getTaskPath(task: listUserTasksQuery) {
    const getPathFn = MAP_PATH_BY_TASK_TYPE.get(task.user_task);

    return getPathFn ? getPathFn(task.task_id, task.organization_id || '') : '/';
  }

  async navigateToTask(task: listUserTasksQuery) {
    const currentTrial = this.mainQuery.getSelectedTrial()?.id;

    if (currentTrial !== task.trial_id) {
      await this.mainService.setTrial(task.trial_id);
    }

    void this.router.navigateByUrl(this.getTaskPath(task));
  }
}
